import "../styles/css/request-estimate.css"
import {useState} from "react";
const EstimateScheduleThanksPage: React.FC = () => {
    const [activeProperty, setActiveProperty] = useState<string>('Residential')
    return (
        <div className='request-body'>
            <div className="container estimate-container">
                <div className="page-card estimate-thanks">
                    <i className="fas fa-thumbs-up thanks-icon"></i>
                    <h1>Thanks!</h1>
                    <p>Your schedule date has been sent to Barreca. Please call or email with any questions or concerns.</p>
                    <p>(847) 970-5900<br /><a href="mailto:barrecablacktop@gmail.com">barrecablacktop@gmail.com</a></p>
                </div>
            </div>
        </div>
    )
}
export default EstimateScheduleThanksPage;